<template>
<div class="alert">
	<div class="alert__container">
		<transition name="testing">
			<div class="alert__main" v-if="alert.message != ''">
				<p class="alert__message">{{alert.message}}</p>
			</div>
		</transition>
	</div>
</div>
</template>


<script>
export default {
	data () {
		return {
		}
	},
	computed: {
		alert () {	
			return this.$store.state.alert.alert
		}
	},
}
</script>

<style>
.alert {
  padding-top: 0 !important;
}
.alert__container {
    position: fixed;
    left: 50%;
    transform: translate(-50%);
    width: 100%;
    height: 20rem;
    pointer-events: none;
    z-index: 10;
    margin-top: 6rem;
}
.alert__main {
	width: 35rem;
    border-radius: 2rem;
    margin: auto;
    background-color: #000000;
    color: white;
    opacity: 1;
    transition: all 0.3s ease;
}
.alert__message {
	font-size: 2rem;
    margin: 0;
    padding: 2rem;
}


.testing-enter-active {
  animation: enter .3s;
}

.testing-leave-active {
  animation: leave .3s;
}

@keyframes enter {
  0% {
    opacity: 0;
    transform: scale(0) translateY(-10rem);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes leave {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0) translateY(-10rem);
  }
}
</style>